global.modules.set({
  is_booted: false,
  async init() {
    if (this.is_booted) {
      return;
    }
    this.is_booted = true;
    $(document).on('click', '.download_pdf', function () {
      const elem = $(this);
      data = elem.data();
      window.open(data.target, '_blank');
    })
  }
})
